export default {
  namespaced: true,
  hikvision_camera: {
    title: "Câmera Hikvision | Câmeras Hikvision",
    hikvision: 'hikvision',
    name: "nome",
    dvr: "DVR",
    status: "estado",
    type: "tipo"
  }
};
